// src/api_scripts/createBusinessHours.js
import { createApiClient } from "../apiClient";

const createBusinessHours = async (orgId, businessHoursData, accessToken, setProgress) => {
  const { name } = businessHoursData;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Business Hours: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // API endpoint for creating a new Business Hours resource
  const relativeUri = `organization/${orgId}/business-hours`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, businessHoursData);

    const newBusinessHours = response.data; // The API returns the created resource directly

    console.log("Create Business Hours API Response Data:", newBusinessHours);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Business Hours "${name}" (ID: ${newBusinessHours.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newBusinessHours; // Return the created business hours object (includes its ID)

  } catch (error) {
    console.error(`Error creating Business Hours "${name}":`, error);

    let errorMessage = `Error creating Business Hours "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createBusinessHours;
